import { useEffect, useState, useRef, useCallback } from "react";
import { Form, Table } from "react-bootstrap";
import AppPagination from "../../Components/AppPagination";
import {
    getConfirmedOrders,
} from "../../Services/orderService";

import { useReactToPrint } from "react-to-print";

import PrintFrontSlip from "../../Components/Print/PrintFrontSlip";
import PrintMoForm from "../../Components/Print/PrintMoForm";
import PrintSingleMOForm from "../../Components/Print/PrintSingleMoForm";
import PrintSingleSlip from "../../Components/Print/PrintSingleSlip";
import PrintLoadSheet from "../../Components/Print/PrintLoadSheet";
import { useSelector } from "react-redux";
import { FaSearch } from "react-icons/fa";

const PrintOrders = () => {
    const [orders, setOrders] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const contentRef = useRef(null);

    const companyPin = useSelector(state => state.auth.companyPin);
    const base64Pin = btoa(companyPin);

    const reactToPrintFn = useReactToPrint({
        content: () => contentRef.current,
    });

    const [filters, setFilters] = useState({
        from: "",
        to: "",
        fromTime: "",
        toTime: "",
        trackingId: "",
    });

    const itemsPerPage = 50;

    // ✅ Format Time
    const formatTime = (time, isEnd = false) => {
        if (!time) return isEnd ? "23:59:59" : "00:00:00";
        return time.length === 5 ? `${time}:00` : time;
    };

    const fetchOrders = useCallback(async () => {
        try {
            const params = {
                limit: 50,
                page,
                trackingId: filters.trackingId || undefined,
                company_pin: base64Pin,
            };

            // ✅ DateTime build
            if (filters.from) {
                params.from = `${filters.from}T${formatTime(filters.fromTime)}`;
            }

            if (filters.to) {
                params.to = `${filters.to}T${formatTime(filters.toTime, true)}`;
            }

            // ✅ AUTO FIX (swap if wrong)
            if (params.from && params.to) {
                const fromDate = new Date(params.from);
                const toDate = new Date(params.to);

                if (fromDate > toDate) {
                    console.warn("Swapping invalid date range");

                    const temp = params.from;
                    params.from = params.to;
                    params.to = temp;
                }
            }

            console.log("Final Params:", params);

            const res = await getConfirmedOrders(params);

            if (res?.status === "success") {
                setOrders(res.data || []);
                setTotalPages(res.totalPages || 1);
            } else {
                setOrders([]);
            }
        } catch (error) {
            console.error("Fetch Orders Error:", error);
            setOrders([]);
        }
    }, [page, filters]);

    useEffect(() => {
        const delay = setTimeout(() => {
            fetchOrders();
        }, 400);

        return () => clearTimeout(delay);
    }, [fetchOrders]);

    const handleDateChange = (e) => {
        const { name, value } = e.target;

        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));

        setPage(1);
    };

    const handleSearchChange = (e) => {
        setFilters((prev) => ({
            ...prev,
            trackingId: e.target.value,
        }));

        setPage(1);
    };

    return (
        <div className="container pb-5">

            <div className="row">
                <div className="col">
                    <h4 className="mb-3">Print Orders</h4>
                </div>
                <div className="col-auto">

                    <div className="row g-2">

                        {/* Print Buttons */}
                        <div className="col-auto">
                            <PrintFrontSlip orders={orders} />
                        </div>

                        <div className="col-auto">
                            <PrintMoForm orders={orders} />
                        </div>

                        <div className="col-auto ">
                            <PrintLoadSheet
                                title="Load Sheet"
                                orders={orders}
                                itemsPerPage={itemsPerPage}
                                page={page}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Filters */}
            <div className="row g-2 mb-3 justify-content-end align-items-end">
                <div className="col-auto">
                    <Form.Label className="oms-label-dark">From Time</Form.Label>
                    <Form.Control
                        type="time"
                        name="fromTime"
                        value={filters.fromTime}
                        onChange={handleDateChange}
                        className="oms-time-input"
                    />


                </div>

                <div className="col-auto">
                    <Form.Label className="oms-label-dark">To Time</Form.Label>
                    <Form.Control
                        type="time"
                        name="toTime"
                        value={filters.toTime}
                        onChange={handleDateChange}
                        className="oms-time-input"
                    />
                </div>

                <div className="col-auto">
                    <Form.Label className="oms-label-dark">From Date</Form.Label>
                    <Form.Control
                        type="date"
                        className="oms-input-dark"
                        name="from"
                        value={filters.from}
                        onChange={handleDateChange}
                    />
                </div>

                <div className="col-auto">
                    <Form.Label className="oms-label-dark">To Date</Form.Label>
                    <Form.Control
                        type="date"
                        className="oms-input-dark"
                        name="to"
                        value={filters.to}
                        onChange={handleDateChange}
                    />
                </div>

                <div className="col-auto">
                    <Form.Label className="oms-label-dark">Search</Form.Label>


                    <div className="oms-search">
                        <input
                            type="text"
                            name="trackingId"
                            placeholder="Search Order Id"
                            value={filters.trackingId}
                            onChange={handleSearchChange}
                        // disabled={loading}
                        />
                        <span style={{ color: "var(--text-muted)", fontSize: 14 }}>
                            <FaSearch />
                        </span>
                    </div>
                </div>

            </div>

            {/* Table */}
            <Table bordered responsive className="d-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Order ID</th>
                        <th>VPP Number</th>
                        <th>Name</th>
                        <th>Contact</th>
                        <th>City</th>
                        <th>Qty</th>
                        <th>Amount</th>
                        <th>Action</th>
                    </tr>
                </thead>

                <tbody>
                    {orders.length ? (
                        orders.map((o, i) => (
                            <tr key={o.id}>
                                <td>{i + 1 + (page - 1) * itemsPerPage}</td>
                                <td>{o.trackingId}</td>
                                <td>{o.VppNumber || "-"}</td>
                                <td>{o.customerName}</td>
                                <td>{o.phoneNumber}</td>
                                <td>{o.city}</td>
                                <td>{o.quantity}</td>
                                <td>{o.amount}</td>
                                <td>
                                    <div className="d-flex gap-2">
                                        <PrintSingleSlip order={o} />
                                        <PrintSingleMOForm order={o} />
                                    </div>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="9" className="text-center">
                                No orders found
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>



            <div className="oms-table-wrap">
                <div className="oms-table-header">
                    <div>
                        <span className="oms-table-title">Order Records</span>
                        <span className="oms-table-count">{orders.length} orders</span>
                    </div>
                </div>
                {orders.length === 0 ? (
                    <div className="oms-empty">
                        <div className="oms-empty-icon">🔍</div>
                        <div className="oms-empty-text">No orders found</div>
                    </div>
                ) : (
                    <div style={{ overflowX: "auto" }}>
                        <table>
                            <thead>
                                <tr>

                                    <th>#</th>
                                    <th>Order ID</th>
                                    <th>VPP Number</th>
                                    <th>Name</th>
                                    <th>Contact</th>
                                    <th>City</th>
                                    <th>Qty</th>
                                    <th>Amount</th>
                                    <th>Action</th>

                                </tr>
                            </thead>
                            <tbody>
                                {orders.map((order, index) => {
                                    // const st = STATUS_CONFIG[order.is_confirmed] || STATUS_CONFIG.pending;

                                    return (
                                        <tr key={order.id}>

                                            {/* INDEX */}
                                            <td>{index + 1 + (page - 1) * itemsPerPage}</td>

                                            {/* TRACKING */}
                                            <td>
                                                <div className="oms-track-id">{order.trackingId}</div>
                                            </td>

                                            {/* VPP */}
                                            <td>
                                                <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
                                                    {order.VppNumber || <span style={{ opacity: 0.4 }}>—</span>}
                                                </div>
                                            </td>

                                            {/* CUSTOMER */}
                                            <td>
                                                <div className="oms-customer" style={{ textTransform: "capitalize" }}>
                                                    {order.customerName}
                                                </div>
                                            </td>

                                            {/* PHONE */}
                                            <td>
                                                <div className="oms-phone" style={{ whiteSpace: "pre" }}>
                                                    {order.phoneNumber?.replace(/\r\n/g, "\n")}
                                                </div>
                                            </td>
                                            {/* PHONE */}
                                            <td>
                                                <div className="oms-address" title={order.address}>
                                                    {order.city || "-"}
                                                </div>
                                            </td>

                                            <td>
                                                <div className="oms-customer" style={{ textTransform: "capitalize" }}>
                                                    {order.quantity}
                                                </div>
                                            </td>

                                            {/* AMOUNT */}
                                            <td>
                                                <div className="oms-amount" style={{ color: "var(--green)" }}>
                                                    ₨{parseInt(order.amount || 0).toLocaleString()}
                                                </div>
                                            </td>


                                            {/* STATUS CHANGE DROPDOWN */}
                                            <td>
                                                <div className="oms-actions">

                                                    <PrintSingleSlip order={order} />
                                                    <PrintSingleMOForm order={order} />

                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
                <div className="oms-table-footer ">


                    <AppPagination
                        page={page}
                        totalPages={totalPages}
                        onPageChange={setPage}
                    />
                </div>
            </div>

        </div>
    );
};

export default PrintOrders;